// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpGdprSinLogoP6 extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.gdpr.sin_logo.p_6";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpGdprSinLogoP6 {
        this.VALUES ??= this.completar({
            "valor": {
                "es": "Almacenar la información en un dispositivo y/o acceder a ella , Datos de localización geográfica precisa e identificación mediante análisis de dispositivos , Publicidad y contenido personalizados, medición de publicidad y contenido, investigación de audiencia y desarrollo de servicios , uso de cookies técnicas o de preferencias."
            },
            "defecto": "Almacenar la información en un dispositivo y/o acceder a ella , Datos de localización geográfica precisa e identificación mediante análisis de dispositivos , Publicidad y contenido personalizados, medición de publicidad y contenido, investigación de audiencia y desarrollo de servicios , uso de cookies técnicas o de preferencias."
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
